export const datePickerWidth = {
  // when it's not alone on a row
  short: 208,
  // when it's alone on a row
  default: 270,
};
